/**
 * Intelligence Thesis - Executive summary synthesis.
 *
 * 2-3 paragraph synthesis of who the executive is beyond the bio.
 */

interface IntelligenceThesisProps {
  thesis?: string;
  synthesizedBio?: string;
  dataGaps?: string[];
}

export function IntelligenceThesis({ thesis, synthesizedBio, dataGaps = [] }: IntelligenceThesisProps) {
  const content = thesis || synthesizedBio;

  if (!content) {
    return (
      <div className="rounded-lg border-2 border-dashed border-gray-200 p-6">
        <h3 className="text-lg font-semibold text-gray-900 mb-3">Intelligence Thesis</h3>
        <div className="text-center text-gray-500">
          <svg className="mx-auto h-10 w-10 text-gray-400" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
          </svg>
          <p className="mt-2 text-sm">
            Intelligence thesis will be generated when more data is available.
          </p>
        </div>
      </div>
    );
  }

  return (
    <div className="space-y-4">
      <div className="flex items-center justify-between">
        <h3 className="text-lg font-semibold text-gray-900">
          {thesis ? 'Intelligence Thesis' : 'Executive Summary'}
        </h3>
        {!thesis && synthesizedBio && (
          <span className="text-xs text-gray-500">Based on available bio data</span>
        )}
      </div>

      <div className="prose prose-sm max-w-none">
        <p className="text-gray-700 leading-relaxed whitespace-pre-line">
          {content}
        </p>
      </div>

      {dataGaps.length > 0 && (
        <div className="mt-4 rounded-lg bg-amber-50 border border-amber-200 p-3">
          <div className="flex items-start gap-2">
            <svg className="h-5 w-5 text-amber-600 flex-shrink-0 mt-0.5" fill="currentColor" viewBox="0 0 20 20">
              <path fillRule="evenodd" d="M8.257 3.099c.765-1.36 2.722-1.36 3.486 0l5.58 9.92c.75 1.334-.213 2.98-1.742 2.98H4.42c-1.53 0-2.493-1.646-1.743-2.98l5.58-9.92zM11 13a1 1 0 11-2 0 1 1 0 012 0zm-1-8a1 1 0 00-1 1v3a1 1 0 002 0V6a1 1 0 00-1-1z" clipRule="evenodd" />
            </svg>
            <div>
              <h4 className="text-sm font-medium text-amber-800">Data Gaps Identified</h4>
              <ul className="mt-1 text-sm text-amber-700 space-y-0.5">
                {dataGaps.map((gap, idx) => (
                  <li key={idx}>• {gap}</li>
                ))}
              </ul>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

export default IntelligenceThesis;
